(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
     

const initializeBenefits = element => new Swiper(element, {
      slidesPerView: 4.5,
      spaceBetween: 100,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 6 },
        650: { 
            slidesPerView: 4.9,
        }
      }
    });
if (window.gummiesPerformance && document.querySelector('[data-gummies-deferred-swiper="benefits"]')) {
  const scheduleBenefits = root => {
    for (const element of root.querySelectorAll('[data-gummies-deferred-swiper="benefits"]')) {
      window.gummiesPerformance.whenNear(element, () => element.swiper || initializeBenefits(element));
    }
  };
  scheduleBenefits(document);
  document.addEventListener('shopify:section:load', event => {
    if (event.target instanceof Element) scheduleBenefits(event.target);
  });
} else initializeBenefits('.benefits-items');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const targetDate = new Date("2026-02-22T10:10:00-05:00");



  function updateWaitlistTimer() {
    const now = new Date();
    let diff = targetDate - now;

    if (diff < 0) diff = 0;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    document.querySelectorAll(".waitlist-timex-box")[0].querySelector(".waitlist-timex-box__title").textContent = days;
    document.querySelectorAll(".waitlist-timex-box")[1].querySelector(".waitlist-timex-box__title").textContent = String(hours).padStart(2, "0");
    document.querySelectorAll(".waitlist-timex-box")[2].querySelector(".waitlist-timex-box__title").textContent = String(minutes).padStart(2, "0");
    document.querySelectorAll(".waitlist-timex-box")[3].querySelector(".waitlist-timex-box__title").textContent = String(seconds).padStart(2, "0");
  }

  updateWaitlistTimer();
  setInterval(updateWaitlistTimer, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sicom-scrolling-line"] && !Shopify.designMode) return;
  try {
      
    function isFullyVisible(element) {
        const rect = element.getBoundingClientRect();
        return rect.width < window.innerWidth;
    }
    function pauseOnFullVisibility() {
        const isPartiallyVisible = (element) => {
            const rect = element.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };
        const scrollingElements = document.querySelectorAll(".scrolling");
        scrollingElements.forEach((scrollingElement) => {
            const scrollingItem = scrollingElement.querySelector(".scrolling-items__item");
            const clonedItem = scrollingItem.cloneNode(true);
            scrollingItem.after(clonedItem);
        });
        const scrollingContainer = document.querySelectorAll(".scrolling__items");
        scrollingContainer.forEach((thisScrollingContainer) => {
            thisScrollingContainer.style.animationPlayState = "running";
        });
    }
    pauseOnFullVisibility();

  } catch(e) { console.error(e); }
})();
})();
